const reassuranceIcones = document.querySelectorAll('.custom-page-chiffre')
const colorClasses = [
  'text-green-pastel',
  'text-pink-pastel',
  'text-orange-pastel',
  'text-violet-pastel',
  'text-thirdly'
]

reassuranceIcones.forEach((reassuranceIcone, index) => {
  reassuranceIcone.classList.add(colorClasses[index])
})
